import { Instance } from 'mobx-state-tree';
import { BillingPortalSessionDtoModelBase } from './BillingPortalSessionDtoModel.base';

/* The TypeScript type of an instance of BillingPortalSessionDtoModel */
export interface BillingPortalSessionDtoModelType extends Instance<typeof BillingPortalSessionDtoModel.Type> {}

/* A graphql query fragment builders for BillingPortalSessionDtoModel */
export { selectFromBillingPortalSessionDto, billingPortalSessionDtoModelPrimitives, BillingPortalSessionDtoModelSelector } from './BillingPortalSessionDtoModel.base';

/**
 * BillingPortalSessionDtoModel
 */
export const BillingPortalSessionDtoModel = BillingPortalSessionDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
